import { QueryObserverOptions } from 'react-query/types/core/types';

export const defaultQueryOptions: QueryObserverOptions = {
  retry: false,
  retryDelay: 3000,
  staleTime: 5 * 1000, //برابر 5 ثانیه. اگر صفر بگذاریم ریکوئست های سرورساید بی تاثیر میشوند
  cacheTime: 2 * 60 * 1000,
  refetchOnWindowFocus: 'always',
  refetchOnMount: true,
  refetchOnReconnect: 'always',
  // notifyOnChangeProps: ['data', 'error', 'isLoading', 'isFetching'],
};

export const cacheableQueryOptions: Partial<QueryObserverOptions<any, any>> = {
  staleTime: Infinity,
  cacheTime: Infinity,
  refetchOnWindowFocus: true, //if not in cache
  refetchOnMount: true, //if not in cache
  refetchOnReconnect: true, //if not in cache
};
